import "./styles.css";
import { startApp } from "./app";

startApp();
